/* Purrity | storewide header. Port of Meditonic mt-header.js (2026-08-27): nav panel, scrolled state, yield to the homepage topbar. Cart count + drawer open are handled by vy-drawer.js through data-vy-cart-count / data-vy-cart-open on the cart button. */
(function () {
  var d = document;

  function boot(head) {
    if (head.prBooted) return;
    head.prBooted = true;

    var burger = head.querySelector('[data-pr-menu]');
    var panel = d.getElementById(head.dataset.prPanel || 'pr-nav-panel');
    var cartBtn = head.querySelector('[data-pr-cart]');
    var countEl = head.querySelector('[data-pr-cart-count]');

    /* ---- scrolled state ---- */
    var ticking = false;
    var annBar = d.querySelector('.vy-promo');
    function paint() {
      head.classList.toggle('is-scrolled', window.scrollY > 8);
      var annH = annBar ? annBar.offsetHeight : 0;
      var top = Math.max(0, annH - window.scrollY) + 'px';
      head.style.setProperty('--pr-top', top);
      if (panel) panel.style.setProperty('--pr-top', top);
    }
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { paint(); ticking = false; });
    }, { passive: true });
    paint();

    /* ---- nav panel ---- */
    if (burger && panel) {
      var items = panel.querySelectorAll('.pr-nav__link, .pr-nav__feature, .pr-nav__foot');
      for (var i = 0; i < items.length; i++) {
        items[i].style.setProperty('--pr-d', (0.06 + i * 0.045).toFixed(3) + 's');
      }

      var open = function () {
        panel.classList.add('is-open');
        burger.setAttribute('aria-expanded', 'true');
        d.body.classList.add('pr-nav-open');
        var sheet = panel.querySelector('.pr-nav__sheet');
        if (sheet) setTimeout(function () { sheet.focus(); }, 180);
      };
      var close = function (focusBack) {
        panel.classList.remove('is-open');
        burger.setAttribute('aria-expanded', 'false');
        d.body.classList.remove('pr-nav-open');
        if (focusBack) burger.focus();
      };

      burger.addEventListener('click', function () {
        if (panel.classList.contains('is-open')) close(false); else open();
      });
      var scrim = panel.querySelector('[data-pr-close]');
      if (scrim) scrim.addEventListener('click', function () { close(false); });
      d.addEventListener('keydown', function (e) {
        if ((e.key === 'Escape' || e.keyCode === 27) && panel.classList.contains('is-open')) close(true);
      });
      // keep focus inside the sheet while it is open
      panel.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab' && e.keyCode !== 9) return;
        var f = panel.querySelectorAll('a[href], button:not([disabled])');
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && d.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && d.activeElement === last) { e.preventDefault(); first.focus(); }
      });
      // a link click navigates, so let the panel shut behind it
      panel.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('a[href]')) close(false);
      });
    }

    /* ---- yield to the homepage topbar ----
       vy-home.js docks .vy-topbar (fixed, top:0, z 70) once the shop module
       scrolls past on the index template. Two fixed bars in the same slot read
       as a mess, so the pill slides away while the topbar is on and comes back
       when it goes. Class-driven, so it costs nothing on pages without it. */
    var topbar = d.querySelector('.vy-topbar');
    if (topbar && window.MutationObserver) {
      var sync = function () { head.classList.toggle('is-yield', topbar.classList.contains('is-on')); };
      new MutationObserver(sync).observe(topbar, { attributes: true, attributeFilter: ['class'] });
      sync();
    }
  }

  function run() {
    d.querySelectorAll('[data-pr-head]').forEach(function (el) {
      try { boot(el); } catch (e) { if (window.console) console.warn('pr-header:', e); }
    });
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', run); else run();
  d.addEventListener('shopify:section:load', run);
})();
